// extracted by mini-css-extract-plugin
export default {"hideTooltip":"D--z","fadeIn":"E--z","delay":"F--z","recommendedSizeTooltip":"G--z"};